import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Stack, Typography, Link as MuiLink, Button, Box } from '@mui/material';
import { useMemo } from 'react';
import { white } from '../colors';
export var ModuleActionVariant;
(function (ModuleActionVariant) {
    ModuleActionVariant["TEXT"] = "text";
    ModuleActionVariant["BUTTON"] = "button";
})(ModuleActionVariant || (ModuleActionVariant = {}));
export var ModuleIconVariant;
(function (ModuleIconVariant) {
    ModuleIconVariant["DEFAULT"] = "default";
    ModuleIconVariant["CONTAINED"] = "contained";
})(ModuleIconVariant || (ModuleIconVariant = {}));
export const Module = ({ sx = {}, children, title, titleVariant = 'h4', text, textVariant = 'body1', icon: Icon, iconVariant, color, gap = 0, action, showOverlay = false, linkComponent = 'a' }) => {
    const rootStyles = useMemo(() => {
        const _styles = {
            height: '100%',
            position: 'relative',
            ...styles.root,
            ...sx.root
        };
        color && (_styles.backgroundColor = color);
        showOverlay &&
            Object.assign(_styles, {
                '&:before': styles.overlay
            });
        return _styles;
    }, [color, showOverlay]);
    const iconStyles = useMemo(() => {
        const _styles = {
            position: 'absolute',
            top: 24,
            right: 24,
            '& svg': styles.svg,
            ...sx.icon
        };
        if (iconVariant === 'contained') {
            Object.assign(_styles, {
                backgroundColor: color,
                ...styles.iconContained
            });
        }
        return _styles;
    }, [iconVariant, color, gap]);
    return (_jsx(Card, { sx: rootStyles, raised: false, elevation: 0, children: _jsxs(CardContent, { sx: { ...styles.content, ...sx.content }, children: [Icon && (_jsx(Box, { sx: iconStyles, children: _jsx(Icon, {}) })), (title || text) && (_jsxs(Stack, { gap: gap, children: [title && (_jsx(Typography, { variant: titleVariant, sx: sx.title, children: title })), text && (_jsx(Typography, { variant: textVariant, sx: sx.text, children: text })), action && (_jsx(_Fragment, { children: action.variant === 'text' ? (_jsx(MuiLink, { sx: sx.action, component: linkComponent, href: action.link, children: action.label })) : (_jsx(Button, { sx: {
                                    ...styles.actionButton,
                                    ...sx.action
                                }, size: "small", variant: "contained", LinkComponent: linkComponent, href: action.link, children: action.label })) }))] })), children] }) }));
};
const styles = {
    root: {
        boxShadow: '0 7px 17px rgba(0, 0, 0, 0.1)',
        borderRadius: 3,
        overflow: 'hidden'
    },
    content: {
        position: 'relative',
        p: 3
    },
    svg: {
        width: 30,
        height: 30,
        color: white,
        float: 'left',
        position: 'relative',
        zIndex: 1
    },
    iconContained: {
        padding: '10px',
        borderRadius: '50%',
        border: '2px solid #fff',
        aspectRatio: 1,
        '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: '50%',
            display: 'block',
            backgroundColor: 'rgba(255,255,255, 0.1)',
            zIndex: 0
        }
    },
    actionButton: {
        alignSelf: 'flex-start',
        backgroundColor: 'rgba(255,255,255,.4)',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,.6)'
        }
    },
    overlay: {
        content: '""',
        position: 'absolute',
        aspectRatio: 1,
        top: 0,
        left: 0,
        bottom: 0,
        background: 'linear-gradient(205deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
        zIndex: 0,
        clipPath: 'polygon(100% 0, 0 0, 0 100%)'
    }
};
